import { conversationClient, ImResponse } from '.';

export interface putTalkAiReplyConfBody {
  conversationId: Conversation.Conversation['conversationId'];
  enable: boolean;
  minutes: number;
  reason: Conversation.PauseReplyReason;
}
export const putTalkAiReplyConf = (body: putTalkAiReplyConfBody) => {
  return conversationClient.put<
    ImResponse<Pick<Conversation.Conversation, 'pauseAiReply' | 'pauseAiReplyEndMillis'>>
  >('/aiReply/pauseAiReply', body);
};
